import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M18.5962 37.4054C18.9578 37.783 19.4641 38 19.9944 38C20.5248 38 21.023 37.783 21.3926 37.4054L34.8926 23.2625C35.6319 22.4911 35.5998 21.2696 34.8283 20.5384C34.0569 19.8071 32.8355 19.8312 32.1042 20.6027L21.923 31.258V3.92857C21.923 2.85982 21.0632 2 19.9944 2C18.9257 2 18.0658 2.85982 18.0658 3.92857V31.258L7.89263 20.5946C7.15334 19.8232 5.93995 19.7991 5.16852 20.5304C4.39709 21.2616 4.37299 22.483 5.10424 23.2545L18.6042 37.3973L18.5962 37.4054Z" })
});
export default SvgArrowDown;
